<template>
  <v-btn
    class="d-flex fill-height elevation-0 px-0 justify-start"
    v-bind="[$attrs, $props]"
    v-on="$listeners"
    min-height="20px"
    width="100%"
  >
    <img :src="customIcon" class="fill-height" v-if="customIcon" />
    <p
      :class="'mb-0 item__text subtitle-1 ' + classSelectedChildren"
      v-show="!mini"
    >
      {{ textButton }}
      <v-icon
        :color="colorIconShowChildren"
        class="pl-2"
        size="14"
        v-if="hasChildren"
      >
        {{ iconShowChildren }}
      </v-icon>
    </p>
  </v-btn>
</template>
<script>
export default {
  name: "SidebarItem",
  computed: {
    iconShowChildren() {
      return this.selected ? "fa-chevron-up" : "fa-chevron-down";
    },
    colorIconShowChildren() {
      return this.selected ? "secondary" : "gray";
    },
    classSelectedChildren() {
      return this.module ? "" : this.children ? "selected-item pl-1" : "pl-3";
    }
  },
  props: {
    customIcon: {
      type: String,
      default: null
    },
    textButton: {
      type: String
    },
    mini: {
      type: Boolean,
      default: false
    },
    hasChildren: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    children: {
      type: Boolean,
      default: false
    },
    module: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="sass" scoped>
.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before
  opacity: 0 !important
.theme--light.v-btn--active:before
  opacity: 0 !important
.item
  &__text
    margin-left: 14px
    padding-top: 3px
.selected-item
  border-left: 2px solid #059EE4
</style>
